<template>
  <div class="menu-item" @click="isOpen = !isOpen">
    <base-button v-if="showAsNavbarBtn" style="background-color:transparent;width:10rem">
      <a class="title" href="#">
        {{ title }}
      </a>
    </base-button>
    <a v-else class="title" href="#">
      {{ title }}
    </a>
    <base-modal  ref="signUpVisibleProfessional" v-if="signUpVisibleProfessional" v-model="signUpVisibleProfessional" :title="$t('sign-up')" hideClose>
      <professional-sign-up-form :callback="() => { signUpVisibleProfessional = false }"/>
    </base-modal>
    <base-modal  ref="signUpVisiblePatient" v-if="signUpVisiblePatient" v-model="signUpVisiblePatient" :title="$t('sign-up')" hideClose>
      <sign-up-form :callback="() => { signUpVisiblePatient = false }"/>
    </base-modal>
    <base-modal  ref="signUpVisibleCenter" v-if="signUpVisibleCenter" v-model="signUpVisibleCenter" :title="$t('sign-up')" hideClose>
      <center-sign-up-form :callback="() => { signUpVisibleCenter = false }"/>
    </base-modal>

    <transition name="fade" appear>
      <div class="sub-menu" v-if="isOpen">
        <div v-if="showLanguageSelector" class="menu-item-list">
          <lang-selector :enablePortuguese="enablePortuguese" style="margin: 0px !important" class="d-inline-block"></lang-selector>
        </div>
        <hr>
        <div v-for="(item, i) in items" :key="i" class="menu-item-list">
          <div @click.prevent="dropdownOptionClick(item, i)">
            <a style="font-weight:bold; color: #3238c4">{{ item.title }}</a>
          </div>
        </div>
      </div>
    </transition>
    <!-- <transition name="fade" appear>
      <div class="sub-menu" v-if="isOpen">
        <div class="menu-item-list">
          <a style="font-weight:bold; color: #3238c4" @click="() => {signUpVisibleProfessional = true}">{{ $t('professional') }}</a>
          <a style="font-weight:bold; color: #3238c4; margin-top:1rem" @click="() => {signUpVisiblePatient = true}">{{ $t('patients') }}</a>
          <a style="font-weight:bold; color: #3238c4;margin-top:1rem" @click="() => {signUpVisibleCenter = true}">{{ $t('center') }}</a>
      </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
import BaseModal from '../BaseModal.vue'
import LangSelector from '@/components/base/LangSelector'

export default {
  name: 'dropdown',
  components: {
    'sign-up-form': () => import('@/components/forms/SignupForm'),
    'professional-sign-up-form': () => import('@/components/forms/ProfessionalSignupForm'),
    'center-sign-up-form': () => import('@/components/forms/CentersSignupForm'),
    BaseModal,
    LangSelector
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showLanguageSelector: {
      type: Boolean
    },
    enablePortuguese: Boolean,
    showAsNavbarBtn: Boolean
  },
  data () {
    return {
      isOpen: false,
      signUpVisibleCenter: false,
      signUpVisibleProfessional: false,
      signUpVisiblePatient: false,
      signUpVisible: false
    }
  },
  methods: {
    goToForm (form) {
      window.location = this.$helpers.getAppUrl(form)
    },
    dropdownOptionClick (item, i) {
        if (item.href) {
          this.$router.push({path: item.href}).catch(() => { this.$router.go() })
        } else if (item.event) {
          this.$store.commit(item.event)
        } else if (item.click) {
          this.$emit(item.click)
        } else {
          if (i === 0) { this.signUpVisibleProfessional = true } else if (i === 1) { this.signUpVisiblePatient = true } else { this.signUpVisibleCenter = true }
        }
    }
  }
}
</script>

<style lang="scss" scoped>
nav .menu-item .title {
    
    font-weight: bold;

}
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}
nav .menu-item-list {
  margin:1.15rem;
}

nav .menu-item .sub-menu {
  font-size: .875rem;
  top: 4rem;
	right: -2rem;
  position: absolute;
  width: max-content;
	padding: 1rem 2rem;
  z-index: 10;
  border-radius: $border-radius;
  box-shadow: 14px 14px 25px rgba(13,39,80,0.160784);
  padding: 1rem 2rem;
  background-color: $white;
  // width: 10rem;
  /* height: 10rem; */
}
.sub-menu hr {
	margin: {
		top: 0rem;
		bottom: 1rem;
	}
}
.nav-item{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/base/dropdown/Dropdown.vue